const FormCard = ({
  children,
  title,
  subtitle,
  showAccentBar = true,
  className = '',
  onSubmit,
  ...props
}) => {
  const CardWrapper = onSubmit ? 'form' : 'div';

  return (
    <CardWrapper
      className={`bg-white rounded-xl p-6 sm:p-8 border-2 border-slate-900 shadow-retro ${className}`}
      onSubmit={onSubmit}
      {...props}
    >
      {(title || subtitle) && (
        <div className="mb-6">
          {title && (
            <h3 className="text-xl sm:text-2xl font-bold text-slate-900 flex items-center gap-3 mb-2">
              {showAccentBar && (
                <span className="w-1 h-6 sm:h-8 bg-gradient-to-b from-teal-500 to-purple-500 rounded"></span>
              )}
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="text-sm sm:text-base font-medium text-slate-600">
              {subtitle}
            </p>
          )}
        </div>
      )}
      {children}
    </CardWrapper>
  );
};

export default FormCard;
